import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RoadmapRoadmapVisualisationEmptyBoxIndexComponent extends Component {
  @service intl;

  get box() {
    return this.args.box;
  }
  get fillType() {
    if (this.box.type === 'required')
      return this.intl.t('roadmap.required-spot');
    if (this.box.type === 'optional')
      return this.intl.t('roadmap.optional-spot');
    return '';
  }

  get source() {
    return this.args.source;
  }

  @action
  propagateInitiative(e) {
    this.args.onInitiativeSelect(e);
  }
}
